import React from "react";
import { cn } from "../../lib/utils";

interface Props {
	children: React.ReactNode;
	className?: string;
}

function Container(props: Props) {
	const { children, className } = props;

	return (
		<div className={cn("max-w-2xl mx-auto w-[95%] h-full", className)}>
			{children}
		</div>
	);
}

export default Container;
